import React, { Component } from 'react';
import { connect } from 'shalala';
import { Badge } from 'react-bootstrap';

import { useStore } from '../../../../store';
import Table from '../../../../facturotopia/table/Table';

class ReporteNuevosClientesList extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selected: [],
    };
  }

  componentDidMount() {
    const { data } = this.props.list;

    if (data.length === 0) {
      const { filters } = this.props.list;

      this.paginate({
        ...filters,
        page: 1,
        status: 2,
      });
    }
  }

  get columns() {
    return [
      {
        key: 'nombre_comercial',
        title: 'Empresa',
        dataIndex: 'nombre_comercial',
      },
      {
        key: 'rfc',
        title: 'RFC',
        dataIndex: 'rfc',
      },
      {
        key: 'email',
        title: 'Email',
        dataIndex: 'email',
      },
      {
        key: 'created_at',
        title: 'Registro',
        dataIndex: 'created_at',
      },
      {
        key: 'confirm',
        title: 'Producción',
        dataIndex: 'confirm',
        align: 'center',
        render: (item) => {
          return item.config?.activation?.email_confirm ? (
            <Badge variant={'success'}>{'Si'}</Badge>
          ) : (
            <Badge variant={'danger'}>{'No'}</Badge>
          );
        },
      },
    ];
  }

  paginate(meta) {
    const { filters } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      ...meta,
      status: 2,
    });
  }

  handleOnPageChange = (page) => {
    this.paginate({ page });
  };

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  };

  handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState(
      {
        selected: selectedRowKeys,
      },
      () => {
        const { onRowSelectionChange } = this.props;

        onRowSelectionChange && onRowSelectionChange({ selectedRowKeys, selectedRows });
      }
    );
  };

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  getPaginationConfig() {
    const { pagination } = this.props.list;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange,
    };
  }

  render() {
    const { columns } = this.state;
    const { onRowClick } = this.props;
    const { busy, data } = this.props.list;

    return (
      <Table
        loading={busy}
        columns={columns}
        rowKey={'id'}
        data={data}
        pagination={this.getPaginationConfig()}
        onRowClick={onRowClick}
      ></Table>
    );
  }
}

const mapState = (store) => {
  return { list: store.admin.reportes.clientes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.admin.reportes.clientes.list };
};

export default connect(useStore, mapState, mapActions)(ReporteNuevosClientesList);
